import clsx from 'clsx'

export type ProfileBadgeVariant =
  | 'languages'
  | 'areas_of_law'
  | 'legal_services'
  | 'promoted'

type ProfileBadgeProps = {
  variant: ProfileBadgeVariant
  text: string
}

export function ProfileBadge({ variant, text }: ProfileBadgeProps) {
  return (
    <div
      className={clsx(
        'text-xs h-6 flex w-fit items-center py-6 px-2 rounded-[8px]',
        {
          'bg-[#EBF3FF] text-[#020251]': variant === 'languages',
          'bg-[#D0E2FA] text-[#020251]': variant === 'areas_of_law',
          'bg-[#D2F6FF] text-[#020251]': variant === 'legal_services',
          'bg-[#F4F4F4] text-black': variant === 'promoted',
        },
      )}
    >
      {text}
    </div>
  )
}
